import React from 'react';
import styles from './styles.module.css';

/**
 * セレクトボックスコンポーネント
 * @param {Object} props
 * @param {{ value: *, display: string }[]} props.options - 選択肢のオブジェクト配列
 * @param {Function} props.onChange - 選択時に実行するメソッド
 * @param {*} props.defaultValue - 初期選択されている値
 * @returns {JSX.Element}
 */
const SelectBox = ({
  name,
  options,
  onChange,
  value,
  defaultValue,
  scale = 'medium',
  disabled = false,
}) => {
  return (
    <select
      className={`${styles.select} ${styles[scale]}`}
      name={name}
      onChange={onChange}
      value={value}
      defaultValue={defaultValue}
      disabled={disabled}
    >
      {Object.values(options).map(({ value, display }, index) => (
        <option className={styles.option} value={value} key={index}>
          {display}
        </option>
      ))}
    </select>
  );
};

export default SelectBox;
